import { render, staticRenderFns } from "./health-anomalyIndex.vue?vue&type=template&id=55437e4a&scoped=true"
import script from "./health-anomalyIndex.vue?vue&type=script&lang=js"
export * from "./health-anomalyIndex.vue?vue&type=script&lang=js"
import style0 from "./health-anomalyIndex.vue?vue&type=style&index=0&id=55437e4a&prod&scoped=true&lang=css"
import style1 from "./health-anomalyIndex.vue?vue&type=style&index=1&id=55437e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55437e4a",
  null
  
)

export default component.exports